module.exports = {"TXTWCL_Browse_tournaments":{"id":"TXTWCL_Browse_tournaments","defaultMessage":"Περιήγηση στα τουρνουά","track":"Browse tournaments"}}